import React, { useState } from "react";
import { useNavigate, Form, Link } from "react-router-dom";
import { useCookies } from "react-cookie";
import { apiurl, host } from "../../path";
import {
  Adminimg,
  AdminLogo,
  login_side_img,
  Vadhavan,
  VadhavanLogin,
  VadhvanLogo256,
  BankofMaharashtraLogo256
} from "../../public/LoginImages/importimages";
import "./admin.css";
const AdminLogin = () => {
  const navigate = useNavigate();
  const [cookies, setCookie, removeCookie] = useCookies();
  const [form, setform] = useState({
    username: "",
    Password: "",
  });

  const login = async () => {
    try {
      let logincheck = await fetch(apiurl + "/AdminLogin", {
        method: "POST",
        headers: { "Content-Type": "Application/json" },
        body: JSON.stringify({ ...form }),
      });
      logincheck = await logincheck.json();
      console.log("FULL LOGIN RESPONSE =>", logincheck);
      // if (logincheck) {
      //   let a = localStorage.setItem("Token", logincheck)
      //       // let b = localStorage.setItem("FullName", logincheck.User.FullName)
      //        let b=localStorage.setItem("FullName", logincheck.User?.FullName || "")
      //   setCookie("userId", logincheck, { path: '/' })
      //   window.location.href = '/AdminDashboard/ProjectDashboard'
      // }
      if (logincheck?.Token) {
        let a = localStorage.setItem("Token", logincheck.Token);
        let b = localStorage.setItem(
          "FullName",
          logincheck.User?.FullName || "",
        );
        localStorage.setItem("Token", logincheck.Token);
        localStorage.setItem("User", JSON.stringify(logincheck.User));
        localStorage.setItem("FullName", logincheck.User?.FullName || "");
        setCookie("userId", logincheck.Token, { path: "/" });
        // window.location.href = "/AdminDashboard/ProjectDashboard";
          // window.location.href = '/AdminDashboard/ProjectDashboard';
// ----changes default dashbord ---17-08-26
const role = logincheck.User?.Role;

if (role === "State Maker" || role === "State Checker" || role === "State Admin") {
  window.location.href = "/AdminDashboard/ProjectDashboard";
} else {
  window.location.href = "/AdminDashboard/AgencyDashboard";
}


      } else {
        alert("Incorrect id or password");
      }
    } catch (error) {
      console.error("Error in AdminLogin:", error);
    }
  };
    function PasswordManager(e) {
  const input = e.currentTarget.parentNode.querySelector("input");
  const eye = e.currentTarget;
 
  if (input.type === "password") {
    input.type = "text";
    eye.className = "fa-regular fa-eye-slash password-eye";
  } else {
    input.type = "password";
    eye.className = "fa-regular fa-eye password-eye";
  }
}
  const isMobile = window.innerWidth <= 768;
  // return (
  //   <div className="admin-login-container">
  //     <div className="admin-login-image">
  //       <img src={Adminimg} className="admin-login-img" />
  //     </div>

  //     <div className="admin-login-form-container">
  //       <Form
  //         onSubmit={() => login()}
  //         style={{
  //           display: "flex",
  //           justifyContent: "center",
  //           width: "100%",
  //           maxWidth: "400px",
  //           padding: isMobile ? "0 20px" : "0",
  //           borderRadius: "10px",
  //           boxShadow: "2px 2px 6px 2px",
  //           backgroundColor: "#f4f7fe",
  //         }}
  //       >
  //         <div
  //           className="card"
  //           style={{
  //             width: "100%",
  //             backgroundColor: "transparent",
  //             border: "none",
  //             padding: "20px",
  //             borderRadius: "12px",
  //           }}
  //         >
  //           {/* <div style={{ display: 'flex', justifyContent: 'center' }}> <img className="card-img-top" style={{ width: "19rem", display: "grid", alignSelf: "center", marginBottom: '10px', }} src={AdminLogo} alt="Card image cap" /></div> */}
  //           <div className="card-body" style={{ display: "grid", gap: "10px" }}>
  //             <div style={{ display: "grid", justifyContent: "center" }}>
  //               <h3>
  //                 <b>Admin Login</b>
  //               </h3>
  //               <p className="card-text" style={{ color: "#999999" }}>
  //                 Please enter your details
  //               </p>
  //             </div>
  //             <div style={{ paddingBottom: "10px" }}>
  //               <i
  //                 style={{
  //                   position: "relative",
  //                   backgroundColor: "transparent",
  //                   zIndex: 0,
  //                   fontSize: "14px",
  //                 }}
  //               >
  //                 <b>Username</b>
  //               </i>
  //               <input
  //                 style={{
  //                   border: "none",
  //                   borderRadius: "0",
  //                   borderBottom: "3px solid",
  //                   padding: "0px 8px 8px 0px",
  //                   fontSize: "15px",
  //                   fontWeight: "600",
  //                   backgroundColor: "transparent",
  //                 }}
  //                 type="text"
  //                 className="form-control"
  //                 id="username"
  //                 placeholder="Enter Username Here"
  //                 onChange={(e) =>
  //                   setform({ ...form, [e.target.id]: e.target.value })
  //                 }
  //                 required
  //               ></input>
  //             </div>
  //             <div style={{ borderBottom: "3px solid #ee5d50" }}>
  //               <i
  //                 style={{
  //                   position: "relative",
  //                   backgroundColor: "transparent",
  //                   fontSize: "14px",
  //                   color: "#ee5d50",
  //                 }}
  //               >
  //                 <b>Password</b>
  //               </i>
  //               <div style={{ display: "flex", alignItems: "center" }}>
  //                 <input
  //                   className="form-control custom-password-input"
  //                   style={{
  //                     border: "none",
  //                     borderRadius: "0",
  //                     backgroundColor: "transparent",
  //                     outline: "none",
  //                     padding: "0px 8px 8px 0px",
  //                   }}
  //                   type="password"
  //                   id="Password"
  //                   placeholder="Enter Password Here"
  //                   onChange={(e) =>
  //                     setform({ ...form, [e.target.id]: e.target.value })
  //                   }
  //                   required
  //                 ></input>
  //                 <i
  //                   style={{ position: "relative", right: "0px" }}
  //                   className="fa-regular fa-eye"
  //                   onClick={(e) => PasswordManager(e)}
  //                 >
  //                   {" "}
  //                 </i>
  //               </div>
  //             </div>
  //             <div
  //               style={{
  //                 display: "flex",
  //                 justifyContent: "space-between",
  //                 alignItems: "center",
  //                 paddingTop: "10px",
  //               }}
  //             >
  //               <div
  //                 style={{
  //                   display: "flex",
  //                   justifyContent: "center",
  //                   alignItems: "center",
  //                   gap: "0.5rem",
  //                 }}
  //               >
  //                 <input type="checkbox" />
  //                 <p
  //                   style={{
  //                     display: "flex",
  //                     fontWeight: "500",
  //                     margin: "0px",
  //                   }}
  //                 >
  //                   Remember for 30 days
  //                 </p>
  //               </div>
  //               {/* <div style={{ display: 'flex', justifyContent: 'center' }}>
  //                   <p style={{ color: "#999999",margin:'0px' }}><a href='/ForgetPassword'>Forgot Password?</a></p>
  //                 </div> */}
  //             </div>
  //             <div
  //               className="my-3"
  //               style={{ display: "flex", justifyContent: "center" }}
  //             >
  //               <button
  //                 type="submit"
  //                 style={{
  //                   display: "flex",
  //                   alignItems: "center",
  //                   justifyContent: "center",
  //                   width: "16rem",
  //                   height: "3.2rem",
  //                   background:
  //                     "linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )",
  //                   borderRadius: "30px",
  //                   fontSize: "19px",
  //                 }}
  //               >
  //                 Login
  //               </button>
  //             </div>
  //           </div>
  //         </div>
  //       </Form>
  //     </div>
  //   </div>
  // );
 return (
    <div className="admin-login-container">
      <div className="admin-login-image">
        <img src={Adminimg} className="admin-login-img" />
         <div className="login-side-content">
 
    <h2>LRS प्रोजेक्टच्या सुरक्षित वापरासाठी सूचना</h2>
 
    <div className="security-point">
      <span className="arrow">»</span>
      <p>
        Cyber Attack, Virus आणि Malware चे धोके कमी करण्यासाठी, LRS च्या
        सर्व्हरवर लॉगिन करताना System सुरू (डेस्कटॉप / लॅपटॉप) LRS पोर्टलमध्ये
        प्रवेश करताना खात्रीत सुरक्षा उपायांची अंमलबजावणी करणे बाबत.
      </p>
    </div>
 
    <div className="security-point">
      <span className="arrow">»</span>
      <p>
        External storage चा वापर करताना काळजीपूर्वक करणे आवश्यक आहे.
        अनवधानाने त्यात Virus आणि Malware संगणकावर येऊ शकतात त्यामुळे
        डेटा चोरीची शक्यता असते.
      </p>
    </div>
 
    <div className="security-point">
      <span className="arrow">»</span>
      <p>
        Licensed अँटी व्हायरस Software चा वापर करा. अँटी व्हायरस अँप्लिकेशन
        योग्यरीत्या Install केले आहे आणि नियमितपणे अपडेट केले आहे याची खात्री करा.
        इंटरनेट Authorized आणि Licensed Software चा वापर करा.
      </p>
    </div>
 
  </div>
  <div className="login-side-footer">
    <p>
      Contents on this website are owned, updated and managed by the
      <br />
      Liability Register System, Government of Maharashtra. Site is technically designed,
      <br />
      hosted and maintained by Bank of Maharashtra.
      <span> Bank of Maharashtra.</span>
    </p>
     <div ><img src={BankofMaharashtraLogo256} style={{ width: "200px",
          height: "45px", marginTop:"20px"}}/></div>
  </div>
 
      </div>

      <div className="admin-login-form-container">
        <Form
          onSubmit={() => login()}
          // style={{
          //   display: "flex",
          //   justifyContent: "center",
          //   width: "100%",
          //   maxWidth: "400px",
          //   padding: isMobile ? "0 20px" : "0",
          //   borderRadius: "10px",
          //   boxShadow: "2px 2px 6px 2px",
          //   backgroundColor: "#f4f7fe",
          // }}
          className="admin-login-form"
        >

 {/* HEADER */}
        <div className="login-header">
 
          <div className="login-logo-section">
 
           <img
                           src={VadhvanLogo256}
                           className="sidebar-logo"
                           alt="..."
                           style={{height:"30px", width:"30px"}}
                         />
 
            <div className="login-title">
              <div>
                Liability Register System
              </div>
 
              <span>
                (Urban Development Department, Government Of Maharashtra)
              </span>
            </div>
 
          </div>
 
        </div>
 
 

          {/* <div
            className="card"
            style={{
              width: "100%",
              backgroundColor: "transparent",
              border: "none",
              padding: "20px",
              borderRadius: "12px",
            }}
          > */}
            {/* <div style={{ display: 'flex', justifyContent: 'center' }}> <img className="card-img-top" style={{ width: "19rem", display: "grid", alignSelf: "center", marginBottom: '10px', }} src={AdminLogo} alt="Card image cap" /></div> */}
            <div className="login-content">
              <div className="login-heading">
                <h3>
                  <b>Admin Login</b>
                </h3>
                <p className="card-text" style={{ color: "#999999" }}>
                  Please enter your details
                </p>
              </div>
              <div className="login-field">
                 <label>Username</label>
                 <div className="input-wrapper">
                <i className="fa-solid fa-user input-icon"> </i>
                <input 
                  type="text"
                  className="login-input"
                 
                  id="username"
                  placeholder="Enter Username Here"
                  onChange={(e) =>
                    setform({ ...form, [e.target.id]: e.target.value })
                  }
                  required
                ></input>
              </div></div>

                 <div className="input-wrapper">
 
  <i className="fa-solid fa-key input-icon"></i>
 
  <input
    type="password"
    className="login-input"
    id="Password"
    placeholder="Enter Password Here"
    onChange={(e) =>
      setform({
        ...form,
        [e.target.id]: e.target.value
      })
    }
    required
  />
 
  <i
    className="fa-regular fa-eye password-eye"
    onClick={(e) => PasswordManager(e)}
  ></i>
 
</div>
 
              {/* <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  paddingTop: "10px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.5rem",
                  }}
                >
                  <input type="checkbox" />
                  <p
                    style={{
                      display: "flex",
                      fontWeight: "500",
                      margin: "0px",
                    }}
                  >
                    Remember for 30 days
                  </p>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <p style={{ color: "#999999",margin:'0px' }}><a href='/ForgetPassword'>Forgot Password?</a></p>
                  </div>
              </div> */}


               <div className="login-options">
 
            <div className="remember-box">
 
              <input
                type="checkbox"
                id="remember" style={{height:"20px", width:"20px"}}
              />
 
              <label htmlFor="remember" style={{fontSize:"14px"}}>
                Remember for 30 days
              </label>
 
            </div>
 
            <Link
              to="/ForgetPassword"
              className="forgot-password"
            >
              Forgot password?
            </Link>
 
          </div>
 
              
              <div className="login-button-container">
                <button type="submit" className="admin-login-btn"> Login</button>
              </div>
                {/* NOTE */}
          <div className="login-note">
 
            <i className="fa-solid fa-circle-info"></i>
 
            <span style={{fontSize:"14px", whiteSpace:"nowrap"}}>
              <b >Note:</b> Username and Password are Case Sensitive
            </span>
 
          </div>
            </div>
          {/* </div> */}
        </Form>
      </div>
    </div>
  );
};

export default AdminLogin;
